export default {
    namespaced: true,
    state: {
		params: {
			tab: 'number', // number | vin | paramenerts
            type: { code: 'exploration' },
		    number: null,
			vin: null,
			mileage: [],
			engineVolume: [],
            use: {},
			bargain: 1,
		},

		//type: 'number', // number | vin | paramenerts

        /* item: {
            percentiles: [],
            adverts: [],
            registrations: [],
        }, */

        //Dictionaries
		brands: [],
		models: [],
		generations: [],
		modifications: [],
		bodystyles: [],
		drivers: [],
		gearboxes: [],
		options: [],
		cities: [],

		vehicle: [],
		market: [],
		percentiles: {},
		offers: [],

		favorits: [], // вибране
    },
    getters: {
		params(state) {
			return state.params
		},

		type(state) {
			return state.type
		},
		
		brands(state) {
			return state.brands
		},
		models(state) {
			return state.models
		},
		generations(state) {
			return state.generations
		},
		modifications(state) {
			return state.modifications
		},
		bodystyles(state) {
			return state.bodystyles
		},
		drivers(state) {
			return state.drivers
		},
		gearboxes(state) {
			return state.gearboxes
		},
		options(state) {
			return state.options
		},
		cities(state) {
			return state.cities
		},
		
		isset(state) {
			return state.params.number 
				|| state.params.vin 
				|| state.params.brand
				|| state.params.model
				//|| state.params.engine
				//|| state.params.gearbox
		},

		favorits(state) {
			return state.favorits
		},

		/* vehicle(state) {
			return state.vehicle
		},
		market(state) {
			return state.market
		},
		percentiles(state) {
			return state.percentiles
		},
		offers(state) {
			return state.offers
		}, */
    },
    mutations: {
		params (state, data) {
			//state.params = data
			state.params = data?data:[]
		},
		/* type (state, data) {
			state.type = data
		}, */

		brands (state, data) {
			state.brands = data?data:[]
		},
		models (state, data) {
			state.models = data?data:[]
		},
		generations (state, data) {
			state.generations = data?data:[]
		},
		modifications (state, data) {
			state.modifications = data?data:[]
		},
		bodystyles (state, data) {
			state.bodystyles = data?data:[]
		},
		drivers (state, data) {
			state.drivers = data?data:[]
		},
		gearboxes (state, data) {
			state.gearboxes = data?data:[]
		},
		options (state, data) {
			state.options = data?data:[]
		},
		cities (state, data) {
			state.cities = data?data:[]
		},

		favorits (state, data) {
			state.favorits = data?data:[]
		},

		/* vehicle (state, data) {
			if(data) {
				state.vehicle = []
				for (let key in data) {
					state.vehicle.push(data[key])
				}
			} else {
				state.vehicle = []
			}
			//state.vehicle = data?data:[]
		},
		market (state, data) {
			state.market = data?data:[]
		},
		percentiles (state, data) {
			state.percentiles = data?data:{}
		},
		offers (state, data) {
			let arr = data.slice().sort(function(a, b) {
				return a.price - b.price;
			})

			state.offers = arr?arr:[]
		}, */
    },
    actions: {
		clearParam (context) {
			let d = new Date()
			context.commit('params', {
                //type: { code: 'market' },
                type: { },
                number: null,
			    vin: null,
				mileage: [],
				engineVolume: [],
                use: {},
				bargain: 1,
			})

            /* context.commit('item', {
				percentiles: [],
                adverts: [],
                registrations: [],
			})

			context.commit('vehicle', [])
			context.commit('market', [])
			context.commit('percentiles', []) */
		},

		setParams (context, data) {
			context.commit('params', data)
		},

		setBrands (context, data) {
			context.commit('brands', data)
		},
		setModels (context, data) {
			context.commit('models', data)
		},
		setGenerations (context, data) {
			context.commit('generations', data)
		},
		setModifications (context, data) {
			context.commit('modifications', data)
		},
		setBodystyles (context, data) {
			context.commit('bodystyles', data)
		},
		setDrivers (context, data) {
			context.commit('drivers', data)
		},
		setGearboxes (context, data) {
			context.commit('gearboxes', data)
		},
		setOptions (context, data) {
			context.commit('options', data)
		},
		setCities (context, data) {
			context.commit('cities', data)
		},

		setFavorits (context, data) {
			context.commit('favorits', data)
		},
		addFavorit (context, data) {
			context.getters.favorits.push(data)
		},
		removeFavorit (context, data) {
			const index = context.getters.favorits.indexOf(data)
			context.getters.favorits.splice(index, 1);
		},
    },
}